export const getLocalizedField = (obj, field, lang, fallback = "en") => {
    const key = `${field}${lang.charAt(0).toUpperCase() + lang.slice(1)}`;
    return obj[key] || obj[`${field}${fallback.charAt(0).toUpperCase() + fallback.slice(1)}`] || "";
};